import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { companyPreferencesStateSelector } from '~/selectors';

export const useCompanyPreferences = <T extends object>(
  resolveCompanyPreferences: (
    remoteCompanyPreferences: Partial<T> | undefined,
  ) => T,
  key: string,
): { companyWorkspaces: T; hasDataCompanyWorkspaces: boolean } => {
  const { companyPreferences } = useSelector((state: StoreState) => {
    return companyPreferencesStateSelector(state);
  });

  return useMemo(() => {
    const selectorState = companyPreferences[key];

    const companyWorkspaces = resolveCompanyPreferences(selectorState?.data);

    return {
      companyWorkspaces,
      hasDataCompanyWorkspaces: !selectorState?.hasData,
    };
  }, [companyPreferences, resolveCompanyPreferences, key]);
};
